import { Create, SimpleForm, ReferenceInput, AutocompleteInput, TextInput, SelectInput, BooleanInput, required } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const TYPE_CHOICES = [
  { id: 'key_map',   name: 'מיפוי מפתח — תכונה שונה בשם בין מקור ליעד' },
  { id: 'value_map', name: 'מיפוי ערך — ערך שונה בין מקור ליעד' },
  { id: 'match_on',  name: 'השוואה על — תכונת היעד שמשתתפת בהתאמה' },
];

const MatchingRuleCreate = () => (
  <Create title="כלל התאמה חדש">
    <SimpleForm>
      <ReferenceInput source="rule_set_id" reference="matching_rule_sets">
        <AutocompleteInput label="סט כללים" optionText="name" fullWidth validate={required('שדה חובה')} />
      </ReferenceInput>

      <SelectInput source="rule_type" label="סוג כלל" choices={TYPE_CHOICES} fullWidth />

      <Box sx={layout.formGrid}>
        <TextInput source="from_key"   label="מפתח מקור"  fullWidth inputProps={{ dir: 'ltr' }}
          helperText="ריק = כל מפתח" />
        <TextInput source="from_value" label="ערך מקור"   fullWidth inputProps={{ dir: 'ltr' }} />
        <TextInput source="to_key"     label="מפתח יעד"     fullWidth inputProps={{ dir: 'ltr' }}
          helperText="רק ל-key_map" />
        <TextInput source="to_value"   label="ערך יעד"      fullWidth inputProps={{ dir: 'ltr' }} />
      </Box>
      <TextInput source="description" label="תיאור הכלל" fullWidth />
      <BooleanInput source="active" label="כלל פעיל" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default MatchingRuleCreate;
